/* Tabs */
document.addEventListener('click', function (e) {
  var trigger = e.target.closest('[data-tab-trigger]');
  if (!trigger) return;
  var wrap = trigger.closest('tabs-component');
  if (!wrap) return;
  var targetId = trigger.getAttribute('data-tab-trigger');

  wrap.querySelectorAll('.tabs__trigger').forEach(function (t) { t.classList.remove('is-active'); });
  wrap.querySelectorAll('.tabs__panel').forEach(function (p) { p.classList.remove('is-active'); });

  trigger.classList.add('is-active');
  var panel = wrap.querySelector('#' + CSS.escape(targetId)) || wrap.querySelector('.tabs__panel[id="' + targetId + '"]');
  if (panel) panel.classList.add('is-active');
});

/* Wishlist / Compare (localStorage) */
(function () {
  function getList(key) {
    try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
  }
  function setList(key, list) {
    localStorage.setItem(key, JSON.stringify(list));
  }
  function toggle(key, id) {
    var list = getList(key);
    var idx = list.indexOf(id);
    if (idx > -1) { list.splice(idx, 1); } else { list.push(id); }
    setList(key, list);
    return list.indexOf(id) > -1;
  }
  function refreshButtons() {
    var wishlist = getList('teknook_wishlist');
    var compare = getList('teknook_compare');
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      btn.classList.toggle('is-active', wishlist.indexOf(btn.dataset.productId) > -1);
    });
    document.querySelectorAll('[data-compare-toggle]').forEach(function (btn) {
      btn.classList.toggle('is-active', compare.indexOf(btn.dataset.productId) > -1);
    });
  }

  document.addEventListener('click', function (e) {
    var wishBtn = e.target.closest('[data-wishlist-toggle]');
    if (wishBtn) { toggle('teknook_wishlist', wishBtn.dataset.productId); refreshButtons(); }

    var compBtn = e.target.closest('[data-compare-toggle]');
    if (compBtn) { toggle('teknook_compare', compBtn.dataset.productId); refreshButtons(); }
  });

  document.addEventListener('DOMContentLoaded', refreshButtons);
})();

/* Product quantity stepper (product page) */
document.addEventListener('click', function (e) {
  var minus = e.target.closest('[data-qty-minus]');
  var plus = e.target.closest('[data-qty-plus]');
  if (!minus && !plus) return;
  var wrap = (minus || plus).closest('.qty-stepper');
  var input = wrap && wrap.querySelector('input[type="number"]');
  if (!input) return;
  var val = parseInt(input.value, 10) || 1;
  input.value = minus ? Math.max(1, val - 1) : val + 1;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

/* Countdown timers */
(function () {
  function tick(el) {
    var target = new Date(el.dataset.countdown.replace(' ', 'T'));
    var now = new Date();
    var diff = Math.max(0, target - now);
    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    var seconds = Math.floor((diff % 60000) / 1000);
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var d = el.querySelector('[data-cd-days]');
    var h = el.querySelector('[data-cd-hours]');
    var m = el.querySelector('[data-cd-minutes]');
    var s = el.querySelector('[data-cd-seconds]');
    if (d) d.textContent = pad(days);
    if (h) h.textContent = pad(hours);
    if (m) m.textContent = pad(minutes);
    if (s) s.textContent = pad(seconds);
  }
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    tick(el);
    setInterval(function () { tick(el); }, 1000);
  });
})();

/* Mobile filter panel */
document.addEventListener('click', function (e) {
  if (e.target.closest('[data-filter-open]')) {
    var panel = document.getElementById('FilterSidebar');
    if (panel) panel.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  if (e.target.closest('[data-filter-close]')) {
    var panel2 = document.getElementById('FilterSidebar');
    if (panel2) panel2.classList.remove('is-open');
    document.body.style.overflow = '';
  }
});

/* Product gallery thumbnails */
document.addEventListener('click', function (e) {
  var thumb = e.target.closest('[data-gallery-thumb]');
  if (!thumb) return;
  var gallery = thumb.closest('[data-product-gallery]');
  var index = thumb.getAttribute('data-gallery-thumb');
  gallery.querySelectorAll('[data-gallery-slide]').forEach(function (slide) {
    slide.classList.toggle('is-active', slide.getAttribute('data-gallery-slide') === index);
  });
  gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
    t.classList.toggle('is-active', t === thumb);
  });
});

/* Sticky add-to-cart bar on product page */
(function () {
  var buybox = document.querySelector('.product-buybox');
  var stickyBar = document.querySelector('[data-sticky-cart]');
  if (!buybox || !stickyBar) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      stickyBar.classList.toggle('is-visible', !entry.isIntersecting && window.innerWidth < 750);
    });
  }, { threshold: 0 });
  observer.observe(buybox);
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 750) stickyBar.classList.remove('is-visible');
  });
})();

/* Product recommendations (native Shopify recommendations endpoint) */
(function () {
  document.querySelectorAll('product-recommendations[data-url]').forEach(function (el) {
    fetch(el.dataset.url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newEl = doc.querySelector('product-recommendations');
        if (newEl && newEl.innerHTML.trim()) {
          el.innerHTML = newEl.innerHTML;
        }
      })
      .catch(function () {});
  });
})();

/* Recently viewed products (client-rendered from localStorage + /products/{handle}.js) */
(function () {
  var STORAGE_KEY = 'teknook_recently_viewed';

  function getViewed() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch (e) { return []; }
  }

  function recordView(handle) {
    var list = getViewed().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, 12)));
  }

  function renderCard(product) {
    var variant = product.variants[0];
    var image = product.featured_image || (product.images[0] || '');
    var price = (variant.price / 100).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
    return (
      '<a href="' + product.url + '" class="product-card product-card--rail">' +
        '<span class="product-card__media">' +
          '<img src="' + image + '&width=500" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy" width="500" height="500">' +
        '</span>' +
        '<span class="product-card__body">' +
          '<span class="product-card__brand">' + (product.vendor || '') + '</span>' +
          '<span class="product-card__title">' + product.title + '</span>' +
          '<span class="product-card__price-row"><span class="product-card__price-current">' + price + '</span></span>' +
        '</span>' +
      '</a>'
    );
  }

  var el = document.querySelector('recently-viewed-products');
  if (el && el.dataset.currentHandle) {
    recordView(el.dataset.currentHandle);
  }

  if (el) {
    var handles = getViewed().filter(function (h) { return h !== el.dataset.currentHandle; }).slice(0, 8);
    if (handles.length) {
      Promise.all(
        handles.map(function (handle) {
          return fetch('/products/' + handle + '.js').then(function (r) { return (r.ok ? r.json() : null); }).catch(function () { return null; });
        })
      ).then(function (products) {
        var valid = products.filter(function (p) {
          return p && (p.featured_image || (p.images && p.images.length));
        });
        if (!valid.length) return;
        el.innerHTML =
          '<div class="section page-width">' +
            '<div class="section__header"><h2></h2></div>' +
            '<div class="rail">' + valid.map(renderCard).join('') + '</div>' +
          '</div>';
        var heading = el.querySelector('.section__header h2');
        if (heading) heading.textContent = document.documentElement.lang === 'tr' ? 'Son Görüntülenenler' : 'Recently Viewed';
      });
    }
  }
})();
